import { FaMosque, FaHandsHelping, FaUsers } from 'react-icons/fa';
import { FaBookQuran } from 'react-icons/fa6';

const counter = [
    {
        id: 1,
        icon: <FaMosque />, // Mosque icon for Active Centers
        title: 'Active Centers',
        count: '45',
    },
    {
        id: 2,
        icon: <FaBookQuran />, // Quran icon for Students Enrolled
        title: 'Quran Students',
        count: '1200',
    },
    {
        id: 3,
        icon: <FaHandsHelping />, // Helping hands icon for Charity Projects
        title: 'Charity Projects',
        count: '320',
    },
    {
        id: 4,
        icon: <FaUsers />, // People icon for Community Members
        title: 'Community Members',
        count: '8000',
    },
];

export default counter;